<template>
  <div>
    <el-card>
      <div class="page-desc">用于比赛现场选手登台答题的试卷。</div>
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="9">
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        label-width="110px"
        ref="queryFormRef"
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="赛事活动" prop="activityType">
              <el-select
                disabled
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.activityType"
                @change="getRaceSchedules"
              >
                <el-option
                  v-for="item in activityTypeList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.season"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="赛程" prop="raceSchedule">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.raceSchedule"
              >
                <el-option
                  v-for="item in raceSchedules"
                  :key="item.id"
                  :label="item.scheduleName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="有组别/无组别" prop="isGroup">
              <el-select
                style="width: 100%"
                placeholder="请选择"
                v-model="queryForm.isGroup"
                clearable
              >
                <el-option v-for="opt of isGroup_List" :key="opt.value" :label="opt.label" :value="opt.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="组别" prop="formLevel">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.formLevel"
              >
                <el-option
                  v-for="item in dict_group"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="试卷名称" prop="formName">
              <el-input
                v-model="queryForm.formName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            style="width: 100%"
            @click="searchFn"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="resetFn"
            >重置</el-button
          >
        </el-col>
      </el-row>
      </el-form>
    </el-card>
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="12">
          <span class="title_class">试卷列表</span>
        </el-col>
        <el-col :span="12" style="text-align: right;">
          <el-button type="primary" @click="showDialog()"
            >创建试卷</el-button
          >
        </el-col>
      </el-row>
      <!-- 列表表格区域 -->
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="赛季" prop="season"></el-table-column>
        <el-table-column label="试卷名称" prop="formName"></el-table-column>
        <el-table-column label="有组别/无组别" prop="isGroup">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isGroup === 1 ? 'warning' : 'success'" size="mini">
              {{ scope.row.isGroup === 2 ? '无组别' : '有组别' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="赛程" prop="raceSchedule" :formatter="raceScheduleFormatter"></el-table-column>
        <el-table-column label="组别" prop="formLevel" :formatter="groupFormatter"></el-table-column>
        <el-table-column label="创建者" prop="creator"></el-table-column>
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              icon="el-icon-document"
              @click="handleToDetail(scope.row)"
            >查看题目</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
import env from '@/http/env'

export default {
  data () {
    return {
      isGroup_List: this.$userInfo.isGroup_List(), // 参赛方式
      activityTypeList: this.$userInfo.getDataList(this, 'activity_type').then(value => { this.activityTypeList = value }),
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }),
      dict_group: this.$userInfo.dict_group(),
      raceSchedules: [],
      queryForm: {
        pageNum: 1,
        pageSize: 20,
        activityType: String(this.$chnEngStatusCode.activityType),
        season: this.$chnEngStatusCode.defaultSeason,
        raceSchedule: '',
        isGroup: 1,
        formLevel: '',
        formName: ''
      },
      total: 0,
      dataList: [],
      visible: false,
      addForm: {
        activityType: String(this.$chnEngStatusCode.activityType),
        season: this.$chnEngStatusCode.defaultSeason,
        raceSchedule: '',
        formLevel: '',
        quizSet: '',
        formName: ''
      },
      uploadInfo: {
        uploadUrl: `${this.$http.defaults.baseURL}quiz/importExamQuizExcel`,
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        }
      }
    }
  },
  created () {
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    init () {
      this.getRaceSchedules()
    },
    getRaceSchedules (type) {
      this.dataList = []
      this.$http.get('raceSchedule/queryRaceSchedule', { params: { activityType: this.queryForm.activityType } }).then(res => {
        if (res.code === 200) {
          this.raceSchedules = res.data
          this.getList()
        }
      })
    },
    getList () {
      console.log(this.queryForm)
      this.$http.get('national/queryNationalGroupFormLevelPage', { params: this.queryForm }).then(res => {
        if (res.code === 200) {
          this.total = res.data.total
          this.dataList = res.data.list
        }
      })
    },
    searchFn () {
      this.queryForm.pageNum = 1
      this.getList()
    },
    resetFn () {
      this.$refs.queryFormRef.resetFields()
      this.queryForm.activityType = String(this.$chnEngStatusCode.activityType)
      this.queryForm.season = this.$chnEngStatusCode.defaultSeason
      this.getRaceSchedules()
    },
    handleCurrentChange (e) {
      this.queryForm.pageNum = e
      this.getList()
    },
    handleSizeChange (e) {
      this.queryForm.pageSize = e
      this.getList()
    },
    handleToDetail (item) {
      this.$router.push(`/academic_Management/pad_paper_detail_list?id=${item.id}&paper=${item.formName}&type=2&season=${item.season}&isGroup=${item.isGroup}&activityType=${item.activityType}`)
    },
    groupFormatter (data) {
      return data.formLevel ? this.dict_group.find(item => item.dictCode === data.formLevel).dictLabel : '--'
    },
    raceScheduleFormatter (data) {
      return this.raceSchedules.find(item => item.id === String(data.raceSchedule)).scheduleName
    },
    showDialog () {
      this.visible = true
    },
    handleClose () {
      this.visible = false
    },
    // 下载模板
    downLoadFn () {
      var downLoadUrl = env.baseIP + 'quiz/importExamQuizExcel'
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, {})
    },
    beforeUpload (file) {
      if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.$message.error('请选择Excel文件上传')
        return false
      }
    },
    uploadSuccess (res) {
      if (res.code === 200) {
        this.$message.success('上传成功')
        this.visible = false
        this.searchFn()
      } else {
        this.$message.error(res.msg)
      }
      this.$refs.uploadFileRef.clearFiles()// 清除文件
    },
    uploadError (error) {
      console.log('uploadError', error)
    }
  }
}
</script>
<style scoped lang="less">
.tip{
  line-height: initial;
  color: #409eff;
  font-size: 12px;
  cursor: pointer;
  width: 74px;
}
.rule-tip{
  color: #999;
  font-size: 12px;
  line-height: 20px;
  margin-top: 10px;
}
.el-upload__tip{
  margin-top: 0;
  line-height: 20px;
}
</style>
